import { SelectorTitleExtras } from "slot-definitions"
import { isEnabled } from "lib/@components/feature"
import { RegimeTableColumns } from "routes/regime/regime-management/regime-management-event-definitions.mjs"
import {
    RegimeItemDescription,
    RegimeItemSummary,
} from "routes/regime/regime-management/regime-management-slot-definitions"
import "./feature-flag-regime-schedule-counts"
import { REGIME_SCHEDULE_COUNTS_FEATURE } from "./regime-schedule-counts-constants.mjs"
import { SelectorRegimeScheduleTotal } from "./selector-regime-schedule-total"
import { ListRegimeScheduleTotal } from "./list-regime-schedule-total"
import { ListRegimeScheduleDescription } from "./list-regime-schedule-description"
import { TableRegimeScheduleTotal } from "./table-regime-schedule-total"
import { readListedRegimeScheduleTotal } from "./use-listed-regime-schedule-total"

SelectorTitleExtras.plug(<SelectorRegimeScheduleTotal priority={400} />)
RegimeItemSummary.plug(<ListRegimeScheduleTotal />)
RegimeItemDescription.plug(<ListRegimeScheduleDescription />)
RegimeTableColumns.handleOnce(addSchedulesColumn)

function addSchedulesColumn({ columns }) {
    // Without the flag the regime table keeps its usual columns, rather than an empty one.
    if (!isEnabled(REGIME_SCHEDULE_COUNTS_FEATURE)) return
    columns.push({
        field: "schedules",
        label: "Schedules",
        width: 120,
        align: "right",
        sortable: true,
        value: scheduleCount,
        cell: <TableRegimeScheduleTotal />,
    })
}

// Regimes without a count sort before 0, like any other empty value in the table.
function scheduleCount(item) {
    return readListedRegimeScheduleTotal(item)?.count
}
